// extracted by mini-css-extract-plugin
export default {"DeliveryHistoryModal":"DeliveryHistoryModal_DeliveryHistoryModal__22A09"};